module.exports = __webpack_public_path__ + "img/tonga.02f4076e.svg";